import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const AllChart = ({ temperature, humidite, co2, ethylene, annotation, name, isDoorsChecked }) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isAnnotationAvailbe, setIsAnnotationAvailbe] = useState(false);
    const [chartKey, setChartKey] = useState(0);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const [strokeWidth, setStrokeWidth] = useState(2.5);

    useEffect(() => {
        const handleResize = () => {
            setStrokeWidth(window.innerWidth <= 500 ? 1 : 2.5);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Refresh the chart when any of these dependencies change
    useEffect(() => {
        setChartKey(prevKey => prevKey + 1);
    }, [temperature, humidite, co2, ethylene, annotation, name, isDoorsChecked]);

    const options = {
        chart: {
            height: 600,
            type: 'line',
            stacked: false,
            zoom: {
                type: 'x',
                enabled: true,
                autoScaleYaxis: true,
                allowMouseWheelZoom: false
            },
        },
        colors: ['#F44336', '#458EEF', '#BD6024', '#D0F72A'],
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: [strokeWidth, strokeWidth, strokeWidth, strokeWidth],
            curve: 'smooth',
            lineCap: 'butt',
            connectNulls: false
        },
        xaxis: {
            type: 'datetime',
            tooltip: {
                enabled: false,
            }
        },
        yaxis: [
            {
                seriesName: 'Température (°C)',
                axisTicks: { show: true },
                axisBorder: { show: true, color: '#F44336' },
                labels: { style: { colors: '#F44336' } },
            },
            {
                seriesName: 'Humidité (%)',
                axisTicks: { show: true },
                axisBorder: { show: true, color: '#458EEF' },
                labels: { style: { colors: '#458EEF' } },
            },
            {
                seriesName: 'CO₂ (ppm)',
                opposite: true,
                axisTicks: { show: true },
                axisBorder: { show: true, color: '#BD6024' },
                labels: { style: { colors: '#BD6024' } },
            },
            {
                seriesName: 'Éthylène (ppm)',
                opposite: true,
                axisTicks: { show: true },
                axisBorder: { show: true, color: '#D0F72A' },
                labels: { style: { colors: '#D0F72A' } },
            },
        ],
        tooltip: {
            shared: true,
            y: {
                formatter: function (val) {
                    return val;
                }
            },
            x: {
                formatter: function (val) {
                    var date = new Date(val);
                    return date.toString();
                }
            }
        },
        legend: {
            horizontalAlign: 'center',
            offsetX: 40
        },
        annotations: {
            xaxis: isDoorsChecked ? annotation : [],
        },
    };

    const series = [
        {
            name: 'Température (°C)',
            data: temperature
        },
        {
            name: 'Humidité (%)',
            data: humidite
        },
        {
            name: 'CO₂ (ppm)',
            data: co2
        },
        {
            name: 'Éthylène (ppm)',
            data: ethylene
        }
    ];

    return (
        <div className='bg-white rounded-lg p-4 hidden md:block'>
            <div className='flex justify-between items-center mb-4'>
                <p className='text-2xl lg:text-3xl font-bold'>{name}</p>
                {/* <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        type="checkbox"
                        value=""
                        className="sr-only peer"
                        onChange={handleCheckboxChange}
                        checked={isChecked}
                        disabled={isAnnotationAvailbe}
                    />
                    <div className="w-9 lg:w-11 h-5 lg:h-6 bg-lightgray peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-lightgray after:border after:rounded-full after:h-4 lg:after:h-5 after:w-4 lg:after:w-5 after:transition-all peer-checked:bg-primary"></div>
                    <span className="ms-3 text-sm font-medium">Portes</span>
                </label> */}
            </div>
            <ReactApexChart key={chartKey} options={options} series={series} type="line" height={660} />
        </div>
    );
}

export default AllChart;
